import { Dispatch, DispatchWithoutAction, FC } from 'react'
import { Position } from '../../types'
import './TimelineSelectionHandle.scss'
import { PositionMilliseconds } from '../components/PositionMilliseconds'

interface Props {
  internalPosition: Position
  setInternalPosition: Dispatch<Position>
  setPosition: DispatchWithoutAction
}

export const TimelineSelectionHandle: FC<Props> = ({ internalPosition }) => {
  return (
    <div className="TimelineSelectionHandle">
      <PositionMilliseconds position={internalPosition} />
    </div>
  )
}
